import {
  FaUserCircle,
  FaBook,
  FaBookOpen,
  FaStar,
} from 'react-icons/fa';

// 獨立子菜單項數據，將在手機版中使用（現在為空，因為移除了Finance Research）
export const MobileSubMenuData = [];

export const SidebarData = [
  {
    titleKey: 'sidebar.aboutMe',
    link: '/',
    icon: <FaUserCircle />,
  },
  {
    titleKey: 'sidebar.myWork',
    link: '/my-work',
    icon: <FaStar />,
  },
  {
    titleKey: 'sidebar.book',
    link: '/books',
    icon: <FaBook />,
  },
  {
    titleKey: 'sidebar.myArticles',
    link: '/about',
    icon: <FaBookOpen />,
  },
];
